import { ForumReply, FORUMS_COLLECTION, FORUMS_REPLIES_COLLECTION, FORUMS_REPLY_TIMESTAMP_FIELD, FORUMS_REPLY_LIKES_COUNT_FIELD, FORUMS_REPLY_REPLIES_COUNT_FIELD } from "../../db";
import { FirestoreDatabase as Database, FirestoreTimestampServerValue } from "../../db/common";
import { BaseFirestoreService } from "../FirestoreService";
import { ForumReplyLikesService } from "./ForumReplyLikesService";

/**
 * Forum Service for the replies on a post
 */
export class ForumPostRepliesService extends BaseFirestoreService<ForumReply> {
    constructor(protected db: Database, protected postId: string) {
        super(db);
    }
    protected getCollectionPath(): string {
        return `${FORUMS_COLLECTION}/${this.postId}/${FORUMS_REPLIES_COLLECTION}`;
    }

    public replyLikeService(replyId: string): ForumReplyLikesService {
        return new ForumReplyLikesService(this.firestore, this.postId, replyId);
    }

    //@overwrite no need to specify some args
    create(data: Omit<ForumReply, "post_id" |
        typeof FORUMS_REPLY_TIMESTAMP_FIELD |
        typeof FORUMS_REPLY_LIKES_COUNT_FIELD |
        typeof FORUMS_REPLY_REPLIES_COUNT_FIELD>): Promise<string> {
        return super.create({
            post_id: this.postId,
            timestamp: FirestoreTimestampServerValue,
            replies_count: 0,
            likes_count: 0,
            ...data,
        });
    }
}
